import { Permissions } from '../enums/permissions';

export const rolesOptions = [
  { value: Permissions.SUPER_ADMIN, label: 'Супер Админ' },
  { value: Permissions.ADMIN, label: 'Администратор' },
  { value: Permissions.MANAGER, label: 'Менеджер' },
  { value: Permissions.MECHANIC, label: 'Механик' },
];